import { render } from "./PasswordEdit.vue?vue&type=template&id=4f10010f&scoped=true"
import script from "./PasswordEdit.vue?vue&type=script&lang=js"
export * from "./PasswordEdit.vue?vue&type=script&lang=js"

import "./PasswordEdit.vue?vue&type=style&index=0&id=4f10010f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f10010f"]])

export default __exports__